export enum QuestionType {
  Calculation = 'CALCULATION',
  Proof = 'PROOF',
  ShortAnswer = 'SHORT ANSWER',
  ExtendedResponse = 'EXTENDED RESPONSE',
  MultipleChoice = 'MULTIPLE CHOICE',
  Graphing = 'GRAPHING',
}

export const QUESTION_TYPE_LABELS: Record<QuestionType, string> = {
  [QuestionType.Calculation]: 'Calculation',
  [QuestionType.Proof]: 'Proof',
  [QuestionType.ShortAnswer]: 'Short answer',
  [QuestionType.ExtendedResponse]: 'Extended response',
  [QuestionType.MultipleChoice]: 'Multiple choice',
  [QuestionType.Graphing]: 'Graphing / diagrams',
};

export enum QuestionGuideType {
  ExemplarAnswer = 'exemplarAnswer',
  MarkersNotes = 'markersNotes',
  MinimumAnswer = 'minimumAnswer',
  AnswersCouldInclude = 'answersCouldInclude',
}

export enum QuestionGuideLabel {
  ExemplarAnswer = 'Exemplar Answer',
  MarkersNotes = "Marker's Notes",
  MinimumAnswer = 'Minimum Answer',
  AnswersCouldInclude = 'Answers Could Include',
}
